import React from 'react';
import {
  LOAD_1_PRODUCT_PER_ROW,
  LOAD_2_PRODUCTS_PER_ROW,
  LOAD_3_PRODUCTS_PER_ROW,
  LOAD_4_PRODUCTS_PER_ROW,
} from '../productListConstants';
import {
  TemplateFor1CS,
  Template2ColsR1xC1,
  Template3ColsR1xC1,
  Template4ColsR1xC1,
  Template3ColsR1xC2,
  Template3ColsR1xC3,
  Template4ColsR1xC2,
  Template2ColsR2xC1,
  Template3ColsR2xC1,
  Template4ColsR2xC1,
  Template3ColsR2xC2,
  Template4ColsR2xC2,
  TemplateForProducts,
} from './templateCollection';

const TemplateSwitcher = props => {
  const TEMPLATES_MAP = {
    template_2_cols_R1xC1: (
      <Template2ColsR1xC1
        key={`Template2ColsR1xC1_${props.row}_${props.products.length ? props.products[0] : props.contentSpot.id}`}
        {...props}
      />
    ),
    template_3_cols_R1xC1: (
      <Template3ColsR1xC1
        key={`Template3ColsR1xC1_${props.row}_${props.products.length ? props.products[0] : props.contentSpot.id}`}
        {...props}
      />
    ),
    template_4_cols_R1xC1: (
      <Template4ColsR1xC1
        key={`Template4ColsR1xC1_${props.row}_${props.products.length ? props.products[0] : props.contentSpot.id}`}
        {...props}
      />
    ),
    template_3_cols_R1xC2: (
      <Template3ColsR1xC2
        key={`Template3ColsR1xC2_${props.row}_${props.products.length ? props.products[0] : props.contentSpot.id}`}
        {...props}
      />
    ),
    template_3_cols_R1xC3: (
        <Template3ColsR1xC3
            key={`Template3ColsR1xC3_${props.row}_${props.products.length ? props.products[0] : props.contentSpot.id}`}
            {...props}
        />
    ),
    template_4_cols_R1xC2: (
      <Template4ColsR1xC2
        key={`Template4ColsR1xC2_${props.row}_${props.products.length ? props.products[0] : props.contentSpot.id}`}
        {...props}
      />
    ),
    template_2_cols_R2xC1: (
      <Template2ColsR2xC1
        key={`Template2ColsR2xC1_${props.row}_${props.products.length ? props.products[0] : props.contentSpot.id}`}
        {...props}
      />
    ),
    template_3_cols_R2xC1: (
      <Template3ColsR2xC1
        key={`Template3ColsR2xC1_${props.row}_${props.products.length ? props.products[0] : props.contentSpot.id}`}
        {...props}
      />
    ),
    template_4_cols_R2xC1: (
      <Template4ColsR2xC1
        key={`Template4ColsR2xC1_${props.row}_${props.products.length ? props.products[0] : props.contentSpot.id}`}
        {...props}
      />
    ),
    template_3_cols_R2xC2: (
      <Template3ColsR2xC2
        key={`Template3ColsR2xC2_${props.row}_${props.products.length ? props.products[0] : props.contentSpot.id}`}
        {...props}
      />
    ),
    template_4_cols_R2xC2: (
      <Template4ColsR2xC2
        key={`Template4ColsR2xC2_${props.row}_${props.products.length ? props.products[0] : props.contentSpot.id}`}
        {...props}
      />
    ),
    template_for_1_CS: (
      <TemplateFor1CS
        key={`TemplateFor1CS_${props.row}_${props.products.length ? props.products[0] : props.contentSpot.id}`}
        {...props}
      />
    ),
    template_for_1: (
      <TemplateForProducts
        key={`TemplateFor1_${props.row}_${props.products.length ? props.products[0] : props.contentSpot.id}`}
        columns={LOAD_1_PRODUCT_PER_ROW}
        {...props}
      />
    ),
    template_for_2: (
      <TemplateForProducts
        key={`TemplateFor2_${props.row}_${props.products.length ? props.products[0] : props.contentSpot.id}`}
        columns={LOAD_2_PRODUCTS_PER_ROW}
        {...props}
      />
    ),
    template_for_3: (
      <TemplateForProducts
        key={`TemplateFor3_${props.row}_${props.products.length ? props.products[0] : props.contentSpot.id}`}
        columns={LOAD_3_PRODUCTS_PER_ROW}
        {...props}
      />
    ),
    template_for_4: (
      <TemplateForProducts
        key={`TemplateFor4_${props.row}_${props.products.length ? props.products[0] : props.contentSpot.id}`}
        columns={LOAD_4_PRODUCTS_PER_ROW}
        {...props}
      />
    ),
  };

  return TEMPLATES_MAP[props.template];
};

export default TemplateSwitcher;
